import {serialize} from 'cookie';
import {CookieStorage} from 'cookie-storage';
import type {NextApiResponse} from 'next';
import * as jwt from 'jsonwebtoken';

const TOKEN_NAME = 'token';
const REFRESH_TOKEN_NAME = 'refresh';

function serializeSetTokenCookie(name: string, token: string) {
    const decoded: any = jwt.decode(token);
    const cookie = serialize(name, token, {
        expires: new Date(decoded.exp * 1000),
        httpOnly: true,
        secure: process.env.NODE_ENV === 'production', // if true, cookie will only be set if https (won't be set if http)
        path: '/',
        sameSite: 'lax',
    });
    return cookie;
}

function serializeRemoveTokenCookie(name: string) {
    const cookie = serialize(name, '', {
        maxAge: -1,
        path: '/',
    });
    return cookie;
}

export function setTokenCookie(res: NextApiResponse, token: string) {
    const cookie = serializeSetTokenCookie(TOKEN_NAME, token);
    res.setHeader('Set-Cookie', cookie);
}

export function removeTokenCookie(res: NextApiResponse) {
    const cookie = serializeRemoveTokenCookie(TOKEN_NAME);
    res.setHeader('Set-Cookie', cookie);
}

export function setRefreshTokenCookie(res: NextApiResponse, refreshToken: string) {
    const cookie = serializeSetTokenCookie(REFRESH_TOKEN_NAME, refreshToken);
    res.setHeader('Set-Cookie', cookie);
}

export function removeRefreshTokenCookie(res: NextApiResponse) {
    const cookie = serializeRemoveTokenCookie(REFRESH_TOKEN_NAME);
    res.setHeader('Set-Cookie', cookie);
}

export function setRefreshAndAccessTokenCookies(res: NextApiResponse, refreshToken: string, token: string) {
    const refreshCookie = serializeSetTokenCookie(REFRESH_TOKEN_NAME, refreshToken);
    const tokenCookie = serializeSetTokenCookie(TOKEN_NAME, token);
    res.setHeader('Set-Cookie', [refreshCookie, tokenCookie]);
}

export function removeRefreshAndAccessTokenCookies(res: NextApiResponse) {
    const refreshCookie = serializeRemoveTokenCookie(REFRESH_TOKEN_NAME);
    const tokenCookie = serializeRemoveTokenCookie(TOKEN_NAME);
    res.setHeader('Set-Cookie', [refreshCookie, tokenCookie]);
}

export function getUserIdFromCookie(): string | null {
    return new CookieStorage().getItem('amplifyUserUuid');
}
